import { render, staticRenderFns } from "./Form20.vue?vue&type=template&id=55062452&scoped=true"
import script from "./Form20.vue?vue&type=script&lang=ts"
export * from "./Form20.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=55062452&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55062452",
  null
  
)

export default component.exports